import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Mail, Facebook, Linkedin, Twitter, ArrowUpRight } from 'lucide-react';
import { contact, brand, navLinks } from '../data/mock';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="relative bg-[#0a1b35] text-white pt-20 pb-10 border-t border-[#e8b863]/12">
      <div className="absolute inset-0 bg-grid opacity-20" />

      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 pb-14">
          {/* Brand */}
          <div className="lg:col-span-5">
            <Link to="/" className="inline-block">
              <img src={brand.logo} alt={brand.fullName} className="h-14 w-auto object-contain" />
            </Link>
            <p className="mt-6 text-white/72 text-[15px] leading-relaxed max-w-md">
              A professional consulting firm providing business, financial, compliance,
              institutional, technology and advisory solutions to organizations that
              cannot afford to get it wrong.
            </p>
            <div className="mt-7 flex items-center gap-3">
              {[Facebook, Linkedin, Twitter].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="Social link"
                  className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-[#e8b863] hover:border-[#e8b863] hover:text-[#0a1b35] transition-all duration-300"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Navigate */}
          <div className="lg:col-span-3">
            <h4 className="text-[11px] text-[#e8b863] tracking-[0.28em] uppercase font-semibold mb-5">
              Navigate
            </h4>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    className="group inline-flex items-center gap-2 text-white/75 hover:text-[#e8b863] text-[14.5px] transition-colors"
                  >
                    {l.label}
                    <ArrowUpRight className="w-3.5 h-3.5 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-4">
            <h4 className="text-[11px] text-[#e8b863] tracking-[0.28em] uppercase font-semibold mb-5">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#e8b863] mt-1 flex-shrink-0" />
                <a href={`tel:${contact.phone.replace(/\s/g, '')}`} className="text-white/82 text-[14.5px] hover:text-[#e8b863] transition-colors">
                  {contact.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#e8b863] mt-1 flex-shrink-0" />
                <a href={`mailto:${contact.email}`} className="text-white/82 text-[14.5px] hover:text-[#e8b863] transition-colors break-all">
                  {contact.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#e8b863] mt-1 flex-shrink-0" />
                <span className="text-white/82 text-[14.5px] leading-relaxed">{contact.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-white/65 text-[13px] text-center sm:text-left">
            © {year} Salihi Consulting Services. All rights reserved.
          </p>
          <div className="flex items-center gap-5 sm:gap-6 text-white/65 text-[13px] flex-wrap justify-center">
            <Link to="/privacy-policy" className="hover:text-[#e8b863] transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-[#e8b863] transition-colors">Terms of Use</Link>
            <Link to="/cookies-policy" className="hover:text-[#e8b863] transition-colors">Cookies Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
